import { inProgressStyles as styles } from './styles';

import * as React from 'react';

import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import { CircularProgress } from '@material-ui/core';
import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import accounting from 'accounting';
import ReactCountdownClock from 'react-countdown-clock';

import TerminalPaymentDialogStore from './stores/terminal-payment-dialog-store';

import Button from 'bz-core-controls/controls/general/button';
import { cache } from 'tm3-core/cache';

interface IProps extends WithStyles<typeof styles> {
  terminalPaymentDialogStore?: TerminalPaymentDialogStore;
}

@inject('terminalPaymentDialogStore')
@observer
class TerminalPaymentInProgress extends React.Component<IProps> {
  render() {
    const { terminalPaymentDialogStore, classes } = this.props;
    if (!this.show) {
      return null;
    }
    return (
      <div className={classes.textContainer}>
        <p style={{ textAlign: 'center' }}>
          A payment request for {this.formattedMoney} was sent to the{' '}
          {terminalPaymentDialogStore!.selectedTerminalName} terminal
        </p>
        <span className="text-base">{terminalPaymentDialogStore!.processingStatusMessage}</span>
        <div className={this.className}>
          <ReactCountdownClock
            seconds={TerminalPaymentDialogStore.FAIL_TIMER / 1000} // value is given in ms in the store
            color="#0398dc"
            alpha={0.9}
            size={100}
            weight={10}
          />
        </div>

        <Button flat={true} onClick={terminalPaymentDialogStore!.onCancel}>
          Cancel
        </Button>
      </div>
    );
  }

  @computed
  private get className(): string {
    const { classes } = this.props;
    if (cache.isClick) {
      return classes.clickCountdownContainer;
    }
    return classes.countdownContainer;
  }

  @computed
  private get formattedMoney(): string {
    const { terminalPaymentDialogStore } = this.props;
    return accounting.formatMoney(terminalPaymentDialogStore!.transactionAmount);
  }

  @computed
  private get show(): boolean {
    const { terminalPaymentDialogStore } = this.props;
    return !!terminalPaymentDialogStore!.isProcessing && !terminalPaymentDialogStore!.paymentError;
  }
}

export default withStyles(styles)(TerminalPaymentInProgress);
